import React from 'react'

import { Form, Col } from '_zari/core'

const NombreFormGroup = ({ onChange, value }) => {
  return (
    <Form.Group>
      <Form.Label text='NOMBRE' htmlFor='input-nombre' sm={4} alignRightAt='sm' />
      <Col sm={8}>
        <Form.InputText id='input-nombre' name='input-nombre' onChange={onChange} value={value} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(NombreFormGroup)
